/**
 * Stripe API
 *
 * Endpoints:
 *   POST api/v1/stripe/intent              - createPaymentIntent
 *   POST api/v1/stripe/bank-account-intent - createBankAccountSetupIntent
 */
import { apiClientPostRequest } from '../lib/backendRequest';

const stripeApi = accessToken => ({
  /**
   * Sign payload
   *
   * @param {object} payload
   */
  async createPaymentIntent(method, amount, currency) {
    try {
      const response = await apiClientPostRequest(
        `api/v1/stripe/intent`,
        {
          amount,
          currency,
          method,
        },
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (e) {
      // `error` is the display text. `errorCode` keeps the network flag the string loses
      // (checkout_payment_failure error_code).
      return { error: e.body, errorCode: e.isNetworkError || e.isAborted ? 'network_error' : 'server_error' };
    }
  },

  /**
   * SetupIntent for connecting a US bank account (ACH Direct Debit) through
   * Financial Connections; PRO users on a brand with ACH only (403 otherwise).
   *
   * @returns {Promise<{ data?: { client_secret: string }, error?: string }>}
   */
  async createBankAccountSetupIntent() {
    try {
      const response = await apiClientPostRequest(
        'api/v1/stripe/bank-account-intent',
        {},
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      const json = await response.json();

      return { data: json.data };
    } catch (e) {
      return { error: e.body || 'Bank account setup is not available right now.' };
    }
  },
});

export default stripeApi;
